import React from 'react';
import styled from 'styled-components';
import ErrorPage from '@nile/components/src/Components/ErrorPage';
import envConfig from '@nile/home/src/Config/env';
import { withRouter } from 'react-router-dom';
import {
  getTranslatedText,
  getURLSearchParams,
  NoDataCard
} from '@nile/components';
import { AppProvider } from '@shopify/polaris';
import { injectIntl } from 'react-intl';

function ErrorPages(props) {
  const { location, intl } = props;
  const searchParams = getURLSearchParams();
  const errorPageType =
    location.pathname.split('/')[2] || searchParams.get('code');
  const searchParam = new URLSearchParams(location.search);

  const renderErrorPage = () => {
    switch (errorPageType) {
      case 'configureTfa':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/RestrictedUser.svg)`}
            text={getTranslatedText(intl, 'error.page.config.tfa.title')}
            description={getTranslatedText(
              intl,
              'error.page.config.tfa.description'
            )}
            link="#/configurenewtfa"
          />
        );
      case 'restrictedAccess':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/RestrictedUser.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.restricted.access.title'
            )}
            description={getTranslatedText(
              intl,
              'error.page.config.restricted.access.description'
            )}
          />
        );
      case 'unauthorizedAccess':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/RestrictedUser.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.unauthorized.access.title'
            )}
            description={getTranslatedText(
              intl,
              'error.page.config.unauthorized.access.description'
            )}
          />
        );
      case 'passwordExpired':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/SessionExpired.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.password.expired.title'
            )}
            description={getTranslatedText(
              intl,
              'error.page.config.password.expired.description'
            )}
            link="#/updatenewpassword"
          />
        );
      case 'itemNotFound':
        return (
          <div className="flex actr jctr fhp w100 tcenter">
            <NoDataCard
              imageURL={`url(${envConfig.imageRoot}svg/deleted_error_page.svg)`}
              text={getTranslatedText(intl, 'error.page.item.deleted.title')}
              description={getTranslatedText(
                intl,
                'error.page.item.deleted.description'
              )}
            />
          </div>
        );
      case 'sessionExpired':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/SessionExpired.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.session.expired.title'
            )}
            description={getTranslatedText(
              intl,
              'error.page.config.session.expired.description'
            )}
          />
        );
      case 'accountExpired':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/SessionExpired.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.account.expired.title'
            )}
            description={getTranslatedText(
              intl,
              'error.page.config.account.expired.description'
            )}
          />
        );
      case 'subscriptionExpired':
      case 'trialExpired':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.trial.expired.title'
            )}
            description={getTranslatedText(
              intl,
              'error.page.config.trial.expired.description'
            )}
            linkExternal="https://superops.com/contact-us"
          />
        );
      case 'underMaintenance':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text="Under Maintenance"
            description="Maintenance is currently underway. The application will be temporarily inaccessible."
            showRefreshBtn
          />
        );
      case 'subscriptionPaused':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.subcription.cancelled.title'
            )}
            description={getTranslatedText(intl, 'app.errorCode.564')}
          />
        );
      case 'subscriptionCancelled':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.subcription.cancelled.title'
            )}
            showBtn
            description={getTranslatedText(intl, 'app.errorCode.565')}
          />
        );

      case 'serviceUnavailable':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.service.unavailable.title'
            )}
            description={getTranslatedText(intl, 'app.errorCode.503')}
          />
        );

      case 'serviceTimeout':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.service.timeout.title'
            )}
            description={getTranslatedText(intl, 'app.errorCode.504')}
          />
        );

      case 'connectivityIssue':
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(
              intl,
              'error.page.config.service.connectivity.title'
            )}
            description={getTranslatedText(intl, 'app.errorCode.502')}
          />
        );

      case 'ssoError':
        if (searchParam.get('errorCode') === '1027') {
          return (
            <ErrorPage
              imageURL={`url(${envConfig.imageRoot}svg/ssoEmail.svg)`}
              text={getTranslatedText(intl, 'app.errorCode.1027.title')}
              description={getTranslatedText(
                intl,
                'app.errorCode.1027.description'
              )}
            />
          );
        } else if (searchParam.get('errorCode') === '1028') {
          return (
            <ErrorPage
              imageURL={`url(${envConfig.imageRoot}svg/ssoSaml.svg)`}
              text={getTranslatedText(intl, 'app.errorCode.1028.title')}
              description={getTranslatedText(
                intl,
                'app.errorCode.1028.description'
              )}
            />
          );
        } else if (searchParam.get('errorCode') === '3005') {
          return (
            <ErrorPage
              imageURL={`url(${envConfig.imageRoot}svg/ssoSaml.svg)`}
              text={getTranslatedText(intl, 'common.error.occured')}
              description={getTranslatedText(intl, 'app.errorCode.3005')}
            />
          );
        } else if (searchParam.get('errorCode') === '560') {
          return (
            <ErrorPage
              imageURL={`url(${envConfig.imageRoot}svg/ssoSaml.svg)`}
              text={getTranslatedText(intl, 'common.error.occured')}
              description={getTranslatedText(intl, 'app.errorCode.560')}
            />
          );
        } else if (searchParam.get('errorCode') === '557') {
          return (
            <ErrorPage
              imageURL={`url(${envConfig.imageRoot}svg/ssoSaml.svg)`}
              text={getTranslatedText(intl, 'common.error.occured')}
              description={getTranslatedText(intl, 'app.errorCode.557')}
            />
          );
        }
      default:
        return (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text={getTranslatedText(intl, 'error.page.config.default.title')}
            description={getTranslatedText(
              intl,
              'error.page.config.default.description'
            )}
          />
        );
    }
  };
  return <AppProvider>{renderErrorPage()}</AppProvider>;
}

export default withRouter(injectIntl(ErrorPages));
